import EventEmmiter from 'events';

if (!window.GlobalEventBus) {
  window.GlobalEventBus = new EventEmmiter();
}

export const GlobalEventBus = window.GlobalEventBus;
